import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { EditorialReviewModel, EditorialReviewEntities, buildReviewPath } from 'client/data/models/editorial-review';
import { CorePageParams } from 'site-modules/shared/utils/core-page/params';
import { PricingAd } from 'site-modules/shared/components/native-ad/pricing-ad/pricing-ad';

import { EditorialReviewBody } from './editorial-review-body';
import { isUsedDataAvailable } from './utils';

import './editorial-review.scss';

function EditorialReviewUI({
  editorialReview,
  vehicle,
  embeddedModules,
  isUsed,
  isMobile,
  params,
  showPricingAd,
  hasRouteYearParam,
  showRightColumn,
  showHighlights,
  showBodyScorecard,
  expandReview,
  isReordered,
  showBottomHr,
}) {
  if (!editorialReview || (isUsed && !isUsedDataAvailable(editorialReview))) {
    return null;
  }
  const { reviewLink, firstContent } = editorialReview;

  // All vehicle after 2017(included) has grouped review
  const { articles, media } = firstContent;
  const hasRelatedArticles = firstContent && ((articles && articles.length > 0) || (media && media.length > 0));

  if (!reviewLink && !hasRelatedArticles) {
    return null;
  }

  const contentColumnSize = showRightColumn ? { xs: 12, lg: 8 } : { xs: 12 };

  const reviewBody = (
    <EditorialReviewBody
      params={params}
      vehicle={vehicle}
      embeddedModules={embeddedModules}
      hasRouteYearParam={hasRouteYearParam}
      showHighlights={showHighlights}
      forceShowScorecard={showBodyScorecard}
      expandReview={expandReview}
      isReordered={isReordered}
    />
  );

  // Show FL/FD content if has no editorial review
  if (!reviewLink) {
    return (
      <Row className="preprod-article">
        <Col {...contentColumnSize} className="order-2 order-lg-1">
          {reviewBody}
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <Col {...contentColumnSize}>
        {reviewBody}
        {showBottomHr && <hr className="mt-1_5 mb-2" />}
      </Col>
      {showRightColumn && (
        <Col xs={12} lg={4} className="hidden-lg-down">
          {showPricingAd && (
            <div
              className={classnames('editorial-pricing-card mt-2', {
                'is-wired': !isMobile,
                'is-mobile': isMobile,
              })}
            >
              <PricingAd mobile={isMobile} />
            </div>
          )}
        </Col>
      )}
    </Row>
  );
}

EditorialReviewUI.propTypes = {
  params: CorePageParams.isRequired,
  editorialReview: EditorialReviewEntities.EditorialReview,
  vehicle: PropTypes.shape({
    make: PropTypes.object,
    model: PropTypes.object,
    year: PropTypes.string,
    submodels: PropTypes.object,
    pubStates: PropTypes.object,
  }),
  embeddedModules: PropTypes.shape({
    rangeAndCostModule: PropTypes.node,
    coreSrpModule: PropTypes.node,
  }),
  isUsed: PropTypes.bool,
  isMobile: PropTypes.bool,
  hasRouteYearParam: PropTypes.bool,
  showPricingAd: PropTypes.bool,
  showRightColumn: PropTypes.bool,
  showHighlights: PropTypes.bool,
  showBodyScorecard: PropTypes.bool,
  expandReview: PropTypes.bool,
  isReordered: PropTypes.bool,
  showBottomHr: PropTypes.bool,
};

EditorialReviewUI.defaultProps = {
  editorialReview: null,
  firstContent: null,
  vehicle: null,
  embeddedModules: null,
  isUsed: false,
  isMobile: true,
  hasRouteYearParam: false,
  showPricingAd: false,
  showRightColumn: true,
  showHighlights: false,
  showBodyScorecard: false,
  expandReview: false,
  isReordered: false,
  showBottomHr: true,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const EditorialReview = connect(mapStateToProps)(
  connectToModel(EditorialReviewUI, {
    editorialReview: bindToPath(({ params }) => buildReviewPath(params), EditorialReviewModel),
  })
);
